import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import type { WorkSheet, WorkBook } from 'xlsx';


const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


@Injectable({ providedIn: 'root' })

export class ExcelService {
    constructor() { }

    public async exportAsExcelFile(json: any[], excelFileName: string, extraParam?, sort?): Promise<void> {
        const XLSX = await import('xlsx');
        console.log(json)
        if (sort) {
            let newArray = []
            json.map(j => {
                let newObj = {}
                sort.map(k => {
                    newObj[k] = j[k]
                    return
                })
                newArray.push(newObj)
            })
            json = newArray;
        }
        let ws: WorkSheet;
        /* generate a new workbook with the first three rows */

        if (extraParam) {
            let params = Object.entries(extraParam)
            ws = XLSX.utils.aoa_to_sheet(params);
            XLSX.utils.sheet_add_json(ws, json, { origin: -1 });
        } else {
            ws = XLSX.utils.json_to_sheet(json);
        }

        /* append two more rows without header */

        let objectMaxLength = [];
        for (let i = 0; i < json.length; i++) {
            let value = <any>Object.values(json[i]);
            for (let j = 0; j < value.length; j++) {
                objectMaxLength[j] = 30
            }
        }
        let wscols = [
            { width: objectMaxLength[0] },  // first column
            { width: objectMaxLength[1] }, // second column
            { width: objectMaxLength[2] }, //...
            { width: objectMaxLength[3] },
            { width: objectMaxLength[4] },
            { width: objectMaxLength[5] },
            { width: objectMaxLength[6] },
            { width: objectMaxLength[7] },
            { width: objectMaxLength[8] },
            { width: objectMaxLength[9] }
        ];
        ws["!cols"] = wscols;

        const workbook: WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };

        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    }

    public async exportFromTable(data: any, excelFileName: string) {
        const XLSX = await import('xlsx');
        const ws: WorkSheet = XLSX.utils.table_to_sheet(data);
        const wb: WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        /* save to file */
        XLSX.writeFile(wb, excelFileName + EXCEL_EXTENSION);
    }

    public async tableToJson(data: any) {
        const XLSX = await import('xlsx');
        return new Promise((res, rej) => {
            const ws: WorkSheet = XLSX.utils.table_to_sheet(data, { raw: false });
            let initial = XLSX.utils.sheet_to_json(ws, { raw: true, defval: '' });
            res(initial)
        })
    }

}